import { stripManualLinkForApi, type IManualPlatformLinkData } from './manualPlatformLinkUtils';

/** JSON-safe manual link payload (no File / blob preview). */
export function manualLinkDataForSignupApi(data: IManualPlatformLinkData) {
    return stripManualLinkForApi(data);
}
